// biome-ignore lint/suspicious/noExplicitAny: TODO: fix
export function getErrorCode(error: any): number {
  if (error?.response?.status) {
    return error?.response?.status as number;
  }
  if (Number.isFinite(error)) {
    return error;
  }
  return 500;
}
